export default class DecodedObject {
    constructor(newPosition) {
        this.newPosition = newPosition;
    }
    getNewPosition() {
        return this.newPosition;
    }
}
//# sourceMappingURL=DecodedObject.js.map